// usePresencePolling.ts
// Fallback polling mechanism when channel fails
import { useEffect, useRef } from 'react';

import { supabase } from '@lib/supabase'; // Adjust import as needed

import { mapDbPlayersToAppPlayers } from './presenceUtils';

export function usePresencePolling({ roomId, isPolling, onPlayersUpdate }: any) {
  useEffect(() => {
    if (!isPolling || !roomId) return;
    const interval = setInterval(async () => {
      const { data: dbPlayers, error } = await supabase
        .from('multiplayer_game_room_players')
        .select('*')
        .eq('room_id', roomId);
      if (!error && dbPlayers) {
        onPlayersUpdate(mapDbPlayersToAppPlayers(dbPlayers));
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [isPolling, roomId, onPlayersUpdate]);
}
